// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "14076d2",
    "hash": "14076d2",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "14076d2",
    "semverString": null,
    "version": "10.0.0",
    "date": "2026-10-20T06:19:23.061Z"
};
/* tslint:enable */
